module.exports = __webpack_public_path__ + "img/usability-speak.3117ebbe.svg";